var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15.4946,
    r: 15,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7796 11.1575C21.0506 11.3994 21.0751 11.8208 20.8341 12.0937L14.0491 19.7769C13.8068 20.0512 13.3909 20.0687 13.1273 19.8156L9.20108 16.0447C8.95623 15.8095 8.93279 15.4176 9.14286 15.1497C9.37467 14.8541 9.80634 14.8134 10.0822 15.0666L13.1284 17.862C13.3932 18.1049 13.8007 18.0832 14.0393 17.8135L19.8753 11.212C20.1115 10.9448 20.5142 10.9206 20.7796 11.1575Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkFill);
export default __webpack_public_path__ + "static/media/CheckmarkFill.28835161fd3a8549cac1145bd2db57c7.svg";
export { ForwardRef as ReactComponent };